export const newOrderFromUser = (message, reducers, data, connection) => {
  const { eventsDispatch } = reducers;
  const newMessage = message.payload;
  eventsDispatch({ type: 'ORDER_NEW', payload: newMessage });
}